import styled from "styled-components";
// Functions
import VerifyToken from "../../config/verifyToken";
import useReportAccess from "../../config/useReportAccess";
// Components
import Header from "../../components/header";
import StickyLogo from "../../components/stickyLogo";
import Recsys from "../../components/recsys";

const Main = styled.main`
  margin: auto;
  padding: 20px 0 100px;
  width: 100%;
  max-width: 860px;
  position: relative;
`;

const RecsysView = () => {
  useReportAccess("RECSYS");

  return (
    <>
      {VerifyToken()}
      <Header />
      <Main>
        <StickyLogo />
        <Recsys />
      </Main>
    </>
  );
};

export default RecsysView;
